import { Typography } from "@mui/material"
import { visuallyHidden } from "@mui/utils"
import { CatalogDto, RegulationDto } from "api"
import { useIsDesktop } from "common/MediaQueries"
import { StyledHeaderH2 } from "reusable/wrappers/BodyText"
import styled from "styled-components"
import DownloadButton from "./DownloadButton"
import PollutionTable from "./PollutionTable"
import SafetyOptionsTable from "./SafetyOptionsTable"
import SafetyTable from "./SafetyTable"

const StyledWhiteWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 50px 20px;
  background-color: ${(p) => p.theme.colors.white};
  ${(p) => p.theme.breakpoints.up("md")} {
    padding: 50px;
  }
`
const StyledRegWrapper = styled.div`
  max-width: 1000px;
  text-align: center;
  ${(p) => p.theme.breakpoints.down("sm")} {
    table {
      width: 100%;
    }
  }
`

const StyledCaption = styled(Typography).attrs({ variant: "caption" })`
  display: inline-block;
  margin-top: 10px;
  ${(p) => p.theme.breakpoints.down("sm")} {
    width: 320px;
  }
`

const StyledRegulation = styled.div`
  margin-top: 45px;
  ${(p) => p.theme.breakpoints.down("sm")} {
    margin-top: 25px;
  }
`

const StyledDiv = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  ${(p) => p.theme.breakpoints.down("sm")} {
    flex-direction: column;
  }
`

const StyledPollution = styled.div`
  width: 100%;
  text-align: right;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 50%;
  align-items: flex-start;
  ${(p) => p.theme.breakpoints.down("sm")} {
    width: 100%;
    margin-bottom: 20px;
    img {
      width: 100%;
    }
  }
`

const StyledImage = styled.img`
  height: 100px;
  object-fit: contain;
  max-width: 100%;
`

const StyledButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  ${(p) => p.theme.breakpoints.down("sm")} {
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 0px;
  }
`
const StyledSafety = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  margin-top: 30px;
`

const StyledSafetyWrapper = styled.div`
  display: flex;
  width: 100%;
  align-items: flex-start;
  flex-direction: row;
  flex-wrap: wrap;
  img {
    height: 50px;
  }
`

const StyledImageWrapper = styled.div`
  width: 100%;
  display: flex;
  ${(p) => p.theme.breakpoints.down("sm")} {
    align-items: center;
    justify-content: right;
  }
`

type RegulationPageProps = {
  catalog: CatalogDto[]
  data: RegulationDto
}

const RegulationPage = ({ data, catalog }: RegulationPageProps) => {
  const isDesktop = useIsDesktop()

  // todo we have problem here with the links that we get from backend
  // repeated forward-slashes (//) or backslashes \ are not valid in the href
  return (
    <StyledWhiteWrapper>
      <StyledRegWrapper>
        <Typography sx={visuallyHidden} component={"h2"}>
          קבצים בפורמט PDF
        </Typography>
        <StyledButtonWrapper>
          {catalog?.map(
            (item, index) =>
              item?.name && (
                <DownloadButton
                  link={item?.link}
                  name={item.name}
                  key={index}
                  typeId={item?.typeId}
                />
              )
          )}
        </StyledButtonWrapper>
        <StyledHeaderH2 $margin={isDesktop ? 30 : 55}>
          אבזור בטיחות, זיהום אוויר וצריכת דלק
        </StyledHeaderH2>
        <StyledCaption>{data?.regulationText}</StyledCaption>

        <StyledRegulation>
          <StyledDiv>
            <StyledPollution>
              <StyledImage
                loading="lazy"
                src={data?.pollutionMainImage}
                alt={data?.pollutionMainImageAlt}
              />
              <PollutionTable data={data} />
            </StyledPollution>

            <StyledPollution>
              <StyledImage
                loading="lazy"
                src={data?.safetyMainImage}
                alt={data?.safetyMainImageAlt}
              />
              <SafetyTable data={data} />
            </StyledPollution>
            <StyledSafety>
              <StyledSafetyWrapper>
                <StyledImageWrapper>
                  <StyledImage
                    loading="lazy"
                    src={data?.legend}
                    alt={data?.legendAlt}
                  />
                </StyledImageWrapper>
                {data?.safetyOptionsTable.map((table, i) => (
                  <SafetyOptionsTable
                    names={table.finishingLevelNames}
                    items={table.items}
                    key={i}
                  />
                ))}
              </StyledSafetyWrapper>
            </StyledSafety>
          </StyledDiv>
        </StyledRegulation>
      </StyledRegWrapper>
    </StyledWhiteWrapper>
  )
}

export default RegulationPage
